import { getCdnBaseImageUrl } from './cdn-util'

const REMOTE_ASSETS_PATH =
  /http(s)?:\/\/(franklin-assets\.s3\.amazonaws\.com|cash-f\.squarecdn\.com|cash-images-f\.squarecdn\.com)\//

export const replaceWithCDNImageUrl = ({ url, width }: { url: string | undefined; width?: number }) => {
  let newUrl = url

  if (url && url.match(REMOTE_ASSETS_PATH)) {
    const sourcePath = url.replace(REMOTE_ASSETS_PATH, '')
    newUrl = `${getCdnBaseImageUrl()}/${sourcePath}`
  } else {
    // non CDN url might not accept additional query params
    return url
  }

  const resolutionMultiplier = typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1

  if (width) {
    const imageWidth = Math.ceil(width * resolutionMultiplier)
    newUrl = newUrl + `?width=${imageWidth}`
  }

  return newUrl
}
